import { FC } from 'react';

interface ICrossIconProps {
  stroke?: string;
}

const CrossIcon: FC<ICrossIconProps> = (props) => {
  const { stroke } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="100%"
      height="100%"
      viewBox="0 0 12 12"
    >
      <path
        d="M11 1L1 11M1 1L11 11"
        stroke={stroke ?? 'white'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CrossIcon;
